import { useMutation, useQueryClient } from '@tanstack/react-query';
import { payersApi, type ChartingSubscriberInput } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

interface RunChartingInput {
  locationId: string;
  subscriber?: ChartingSubscriberInput;
}

// Agency-only — runs a real charting call for this payer using the chosen
// location's credentials. Not gated on the location having added this payer
// (see backend listAgencyLocations/triggerChartingManually).
export function useRunCharting(payerId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ locationId, subscriber }: RunChartingInput) =>
      payersApi.triggerCharting(payerId as string, locationId, subscriber),
    onSuccess: () => {
      if (payerId) queryClient.invalidateQueries({ queryKey: payerKeys.map(payerId) });
    },
  });
}
